import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, NavigationEnd, RouterEvent } from "@angular/router";
import { RecordingService } from "../../services/recording/recording.service";
import { RecordingJob } from "../../domain/recording-job";
import { Subscription } from "rxjs";
import { UI } from "../../services/ui.service";
import { ToastrService } from "ngx-toastr";

enum RecordingActiveTab {
  Schedule = 1,
  History,
}

@Component({
  selector: "evrideo-recording",
  templateUrl: "./recording.component.html",
  styleUrls: ["./recording.component.scss"],
})
export class RecordingComponent implements OnInit, OnDestroy {
  selectedTab: RecordingActiveTab = RecordingActiveTab.Schedule;
  tabs = [
    { title: "schedule", type: RecordingActiveTab.Schedule },
    { title: "history", type: RecordingActiveTab.History },
  ];
  recordingServiceFailureSubscription: Subscription;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    public recordingService: RecordingService,
  ) {}

  ngOnInit() {
    this.figureOutTabBasedOnUrl(this.router.url);
    this.router.events.subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {
        this.figureOutTabBasedOnUrl(event.urlAfterRedirects);
      }
    });
    this.recordingServiceFailureSubscription = this.recordingService
      .getFailureAnnouncerObserver()
      .subscribe(this.toastFailure.bind(this));
  }

  toastFailure(msg) {
    this.toastr.error(msg, "Recording Manager");
  }

  figureOutTabBasedOnUrl(url) {
    if (url.toLowerCase().endsWith("history")) {
      this.selectedTab = RecordingActiveTab.History;
    } else {
      this.selectedTab = RecordingActiveTab.Schedule;
    }
  }
  ngOnDestroy(): void {
    if (this.recordingServiceFailureSubscription) {
      this.recordingServiceFailureSubscription.unsubscribe();
    }
  }

  isSceduleTab() {
    return this.selectedTab === RecordingActiveTab.Schedule;
  }
  createNewRecordingJob() {
    this.recordingService.callCreateNewRecordingJob();
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    return this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => {
        this.router.navigate([currentUrl]);
      });
    /*this.recordingService.refreshJobsCache()
      .then(() => {
        const currentUrl = this.router.url;
        return this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate([currentUrl]);
        });
      });*/
  }
}
